import { Button, Flex, Select, Text } from '@chakra-ui/react'
import { useWidget } from '@hooks'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSessionControllerPatchSession } from '~/clinician-api'
import type { SessionSetting, StepProps } from './types'

export const StartRecording: React.FC<StepProps> = ({
  sessionSetting,
  setSessionSetting,
  usingHeadphones,
  setUsingHeadphones,
  clientId,
  sessionId
}) => {
  const history = useHistory()
  const { settings } = useWidget()
  const { mutateAsync: patchSession } = useSessionControllerPatchSession()

  return (
    <Flex height="100%" flexDirection="column">
      <Text fontSize="16px">Session Type</Text>
      <Text fontSize="10px" mb="xsmall">
        This is used to optomize audio and note quality
      </Text>
      <Select
        mb="xsmall"
        value={sessionSetting}
        onChange={e => {
          setSessionSetting(e.target.value as SessionSetting)
          if (e.target.value === 'in-person') {
            setUsingHeadphones(false)
          }
        }}
        borderColor="gray.300"
        borderRadius={
          settings.minifiedViewSettings?.inputs?.borderRadius ?? '5px'
        }
        _active={{ borderColor: 'gray.300' }}
        _focus={{ borderColor: 'gray.300' }}
        _hover={{ borderColor: 'gray.300' }}
      >
        <option value="in-person">In-Person</option>
        <option value="telehealth">Telehealth</option>
      </Select>
      {sessionSetting === 'telehealth' && (
        <Select
          value={usingHeadphones ? 'using-headphones' : 'no-headphones'}
          onChange={e =>
            setUsingHeadphones(e.target.value === 'using-headphones')
          }
          borderColor="gray.300"
          borderRadius={
            settings.minifiedViewSettings?.inputs?.borderRadius ?? '5px'
          }
          _active={{ borderColor: 'gray.300' }}
          _focus={{ borderColor: 'gray.300' }}
          _hover={{ borderColor: 'gray.300' }}
        >
          <option value="no-headphones">No headphones</option>
          <option value="using-headphones">Using headphones</option>
        </Select>
      )}
      <Button
        mt="auto"
        backgroundColor={
          settings.minifiedViewSettings?.buttons?.primaryBackgroundColor ??
          'primary'
        }
        color={
          settings.minifiedViewSettings?.buttons?.primaryTextColor ?? 'white'
        }
        borderRadius={
          settings.minifiedViewSettings?.buttons?.borderRadius ?? '24px'
        }
        borderColor={
          settings.minifiedViewSettings?.buttons?.primaryBorderColor ??
          'primary'
        }
        borderWidth={
          settings.minifiedViewSettings?.buttons?.primaryBorderWidth ?? '1px'
        }
        onClick={async () => {
          await patchSession({
            id: sessionId as string,
            data: {
              isUsingHeadphones: usingHeadphones,
              isTelehealth: sessionSetting === 'telehealth'
            }
          })
          // eslint-disable-next-line
          parent.postMessage(
            {
              type: 'BP_SESSION_RECORDING_STARTED',
              sessionId
            },
            '*'
          )
          history.push(`/mini-widget/patient/${clientId}/session/${sessionId}`)
        }}
      >
        Start Recording
      </Button>
    </Flex>
  )
}
